import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm-.8 3h1.5v6.5H7.2V3zM8 13.5c-.7 0-1.2-.6-1.2-1.2S7.3 11 8 11s1.2.6 1.2 1.2-.5 1.3-1.2 1.3z" /></svg>);